import React from 'react';
import Image from 'next/image';
import {
  Tabs,
  PointsContent,
  PointsHeaderText,
  FlexRow,
  BoxWrap,
} from './styles';
import { Box, Text } from './core';
import { fonts } from './core/Text/typography';
import CounterClipped from './CounterClipped';
import TypeCards from './TypeCards';
import Loader from './Loader';
import { useQueryClient } from '@tanstack/react-query';
import {
  useClaimNft,
} from './query/staking';
import { XNetDashboard } from '../../api/xnetapis';
import {
  StakeState
} from './types';
import { toast } from 'react-toastify';
import styled from 'styled-components';

import TopRightIconImageMobile from "public/assets/airdrop/mobile_top_right_header_icon.svg"; 
import TopLeftIconImageMobile from "public/assets/airdrop/mobile_top_left_header_icon.svg"; 
import TopRightIconImage from "public/assets/airdrop/desktop_top_right_header_icon.svg"; 
import TopLeftIconImage from "public/assets/airdrop/desktop_top_left_header_icon.svg";

const IconContainer = styled.div`
  z-index: 1; /* Ensure icons are above the background */
  @media (max-width: 768px) {
    display: none;
  }
`;

const IconContainerMobile = styled.div`
  z-index: 1; /* Ensure icons are above the background */
  display: none;
  @media (max-width: 768px) {
    display: block;
  }
`;

export const PointsHolder = styled.div`
  width: 100%;
  margin: 0 auto 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  flex: 1;
  height: 100%;
  &.connect {
    background-image: url('/assets/staking/images/loginFrame.avif');
    background-size: cover;
    padding-top: 24px;
    padding-bottom: 12px;
    height: 547px;
    max-height: 547px;
    width: 662px;
  }
  &.stakingHolder, &.farmingHolder {
    height: fit-content;
  }
  @media (max-width: 768px) {
    width: 100%;
    margin-top: 60px;
    flex: auto !important;
    &.connect {
      height: 441px;
      width: 100%;
      background-size: cover;
    }
    &.stakingHolder {
      height: 631px;
      width: 100vw;
    }
  }
`;

export const CardsWrapper = styled.div`
  position: relative;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  padding: 28px 30px;
  padding-bottom: 24px;
  gap: 11px 32px;
  margin-top: 20px;
  height: 439px; 
  overflow-y: scroll;
  &.claimSuc {
    margin-top: 0px;
    margin-bottom: 20px;
  }
  @media (max-width: 768px) {
    padding: 24px 0% 10px;
    margin: 12px 0 16px;
    height: 239px;
    overflow-y: scroll;
    &.stake {
      margin: 12px 0 20px;
    }
  }
`;

export default function StakingUnclaimedComponent(
  { dashboardData, appState, isConnected, 
    token , refreshRequired, setAppState,refetch }: any) {

  const queryClient = useQueryClient();
  const { mutate, isPending } = useClaimNft({
    onSuccess: (data) => {
      queryClient.setQueryData(
        ['dashboard', isConnected, token, refreshRequired],
        (dashboardData: XNetDashboard) => {
          // @ts-ignore
          refetch();
          return dashboardData;
        }
      );
      // queryClient.invalidateQueries({ queryKey: ['dashboard'] });
      setAppState({
        ...appState,
        stakeState: StakeState.CLAIM_SUCESS,
      });
      toast.success('TRANSACTION SUCCESFUL');
      var audio = new Audio('/assets/music/Sfx_Xnet_Success.wav');
      // var audio = new Audio('/assets/music/Sfx_Xnet_Tokens.wav');
      audio.play();
    },
    onError: (error:any) => {
      console.log('error', error);
      toast.success('TRANSACTION FAILED');
      // var audio = new Audio('/assets/music/Sfx_Xnet_Success.wav');
      var audio = new Audio('/assets/music/Sfx_XNET_UI_error.wav');
      // var audio = new Audio('/assets/music/Sfx_Xnet_Tokens.wav');
      audio.play();
      return;
    },
  });

  
  return (
    <PointsHolder>
      {/* <ConnectionHeader /> */}
      <PointsContent>
        <Image
          width={100}
          height={100}
          style={{
            width: '100%',
            maxHeight: '227px',
            position: 'absolute',
            top: '0',
            left: '0',
            zIndex: '-1',
          }}
          src={'/assets/staking/images/widgetTopBackground.png'}
          alt={'bgg'}
        />
        <Tabs
          style={{
            width: '100%',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
          }}
          className="stakingClaimedTab"
        >
          <IconContainer>
            <Image src={TopLeftIconImage} alt="Left Icon" />
          </IconContainer>
          <IconContainerMobile>
          <Image src={TopLeftIconImageMobile} alt="Left Icon" />
          </IconContainerMobile>
          <PointsHeaderText style={{ marginBottom: 5 }}>
            CLAIM NFT
          </PointsHeaderText>
          <IconContainer>
            <Image src={ TopRightIconImage} alt="Right Icon" />
          </IconContainer>
          <IconContainerMobile>
            
            <Image src={ TopRightIconImageMobile} alt="Left Icon" />
          </IconContainerMobile>
        </Tabs>
        <Text
          style={{
            color: "#00C2FF",
            textAlign: "center",
            fontFamily: "BPdotsUnicaseSquare",
            fontSize: "17.653px",
            fontStyle: "normal",
            fontWeight: 700,
            lineHeight: "100%", /* 17.653px */
            letterSpacing: "2.825px",
            textTransform: "uppercase"
          }}
        >
          DIFFERENT NFT RARITIES BOOST STAKING.
          <br />
          CLAIM TO REVEAL RARITY.
        </Text>
        <CardsWrapper className="unclaimed"
        >
          {dashboardData?.nfts.map((nftObj, index) => {
            if (nftObj) {
              return (
                <TypeCards
                  // @ts-ignore
                  nft={{ ...nftObj }}
                  key={index}
                  nftStatus={appState.stakeState}
                  tab={appState.tab}
                />
              );
            }
          })}
        </CardsWrapper>
        <Box
          style={{
            width: '100%',
            background:
              'linear-gradient(180deg, rgba(2, 22, 31, 0) 0%, #02161f 100%)',
            position: 'sticky',
            bottom: '0',
            right: '0',
            zIndex: 9001,
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-end',
            alignItems: 'flex-end',
          }}
        >
          <BoxWrap style={{ width: '248px', height: '60px' }}>
            <CounterClipped
              stopHover={isPending}
              backgroundColor={
                isPending ? 'rgba(3, 23, 31, 1)' : '#00C2FF'
              }
              borderColor={isPending ? 'rgb(4, 44, 58)' : '#00C2FF'}
              variant="singleCut"
              borderOpacity="1"
              styles={{}}
              onClick={mutate}
            >
              {isPending ? (
                <FlexRow
                  style={{
                    zIndex: 1,
                    gap: '12px',
                    alignItems: 'center',
                  }}
                >
                  <Text
                    style={{
                      ...fonts?.TEXT_P1,
                      marginTop: 8,
                      color: 'rgba(0, 194, 255, 1)',
                    }}
                  >
                    PROCESSING
                  </Text>
                  <Loader />
                </FlexRow>
              ) : (
                <Text
                  style={{
                    ...fonts.TEXT_P2,
                    color: '#01161D',
                    zIndex: 1,
                    paddingTop: 6,
                  }}
                >
                  CLAIM NFT
                </Text>
              )}
            </CounterClipped>
          </BoxWrap>
          <Box
            style={{
              height: 168,
              width: '100%',
              background:
                'linear-gradient(180deg, rgba(2, 22, 31, 0) 0%, #02161f 100%)',
              position: 'absolute',
              bottom: '0',
              right: '0',
              zIndex: -1,
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'flex-end',
              alignItems: 'flex-end',
            }}
          ></Box>
        </Box>
      </PointsContent>
    </PointsHolder>
  )
}